module.exports = __webpack_public_path__ + "img/2d3b7d1.jpg";